import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, Table, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import { v4 as uuidv4 } from "uuid";
import { RouterContext } from "../Onboarding";

export default function FacebookAdsAccess(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);
  const [userGrantAccess, setUserGrantAccess] = useState(
    props.teamAccess["Facebook Ads"]["Restricted"] == "1" || props.teamAccess["Facebook Ads"]["Full"] == "1"
  );
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if ((form.checkValidity() === true) && ((props.teamAccess["Facebook Ads"]["Full"] == "1") || props.teamAccess["Facebook Ads"]["Restricted"] == "1") ) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  useEffect(() => {
    if (props.facebookAdsIds.length > 0) return null;
    let newRow = {};
    newRow.frontId = uuidv4();
    newRow.label = "";
    newRow.id = "";
    props.setFacebookAdsIds((rows) => [...rows, newRow]);
  }, []);

  const authenticateFunction = (platform) => {
    window.open(platform["auth_url"], '_blank');
  };

  const deauthorizeFunction = (platform) => {
    window.open(platform["deauth_url"], '_blank');
  };

  const resetMessage = (platformName) => {
    return (`Resetting ${capitalize(platformName)} token will require you to authenticate again`)
  }

  const authButton = (platform) => {
    if (platform.authenticated) {
      return (
        <>
          <Button className="mb-4 btn-lg text-center" variant="danger" onClick={() => deauthorizeFunction(platform)}>
            Reset Token
            <CustomTooltip faClass="text-white far fa-question-circle f18 pl-2" message={resetMessage(platform["title"])} inline={true} />
          </Button>
        </>
      )
    } else {
      return (
        <>
          <Button className="mb-4 btn-lg text-center" variant="success" onClick={() => authenticateFunction(platform)}>
            Authenticate
            <i className="fas fa-cog pl-2" style={{paddingRight: "0px", color: "unset", float: "unset"}}></i>
          </Button>
        </>
      )
    }
  }

  return (
    <>
      <Row className=" px-4 mb-3 pb-3 justify-content-center">
        <Col xl={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Grant Facebook Ads Access</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              On this page you will grant access to Facebook Ads. Please {/*watch the video for the detailed instruction on how to grant access properly, and then*/}
              check the box to indicate the access level granted. It's important to note that checking the access level boxes are solely for reference, and will
              not perform any actions in regards to granting access to your account.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="my-5 justify-content-center">
        <Col xl={5}>
          <Row>
            <Col className="mr-0" md={12}>
              <p className="visby-bold pb-2 light-primary f14">Authenticate with Facebook:</p>
            </Col>
          </Row>
          <Row className="pl-0">
            <Col md={12}>
              <div style={{ backgroundColor: "#E1E1E1", paddingRight: "40px", paddingTop: "20px", paddingLeft: "10px" }}>
                <div className="">
                  <div className="ml-3">
                    {authButton(props.api_platforms["facebook_ads"])}
                    <p className="f-14 light-primary pb-3">{props.api_platforms["facebook_ads"]["authenticated"] ?
                      "You have already authenticated with Facebook Ads. If you need access to clients on a different account, reset your token and reauthenticate."
                      : "You must go through the authentication process before you can pull data from Facebook Ads!"
                      }
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={12}>
              <div style={{ backgroundColor: "#E1E1E1", paddingRight: "10px", paddingBottom: "20px", paddingLeft: "10px" }}>
                <div className="table-responsive">
                  <p className="f12 pt-3 pl-2">Facebook Ads ID</p>
                  <Table className="overflow-hidden">
                    <tbody>
                      {props.facebookAdsIds.map((el, idx) => {
                        return (
                          <tr key={idx}>
                            <td>
                              <Form.Control
                                name={`facebook-ads-id-${idx}`}
                                size="sm"
                                placeholder="ID"
                                style={{ width: "185px" }}
                                value={el.id}
                                onChange={(e) => {
                                  let newFacebookAdsIds = props.facebookAdsIds;
                                  newFacebookAdsIds[idx]["id"] = e.target.value;
                                  props.setFacebookAdsIds([...newFacebookAdsIds]);
                                }}
                                id={`ob-facebook-ads-id${idx}`}
                                required
                                type="text"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <p className="f14 light-primarypt pt-3">Complete as many of the below steps as possible, and check to confirm.</p>
              </div>
              <div className="p-4" style={{ backgroundColor: "#E1E1E1", marginTop: "14px" }}>
                <div className="pb-2 text-left">
                  <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
                  <CustomFormCheck
                    id="ob_facebook_ads_granted"
                    required
                    name="facebook_ads_granted"
                    label="Facebook Ads access granted"
                    dynamic
                    checked={userGrantAccess}
                    onChange={(e) => {
                      setUserGrantAccess(!userGrantAccess);
                    }}
                  />
                  <div>
                    <p className="pl-3 pb-1 f16 primary">Please indicate access granted.</p>
                  </div>

                  <div className="pb-1 pl-3">
                    <CustomFormCheck
                      id="ob_facebook_ads_full"
                      name="facebook_ads_granted_full"
                      label="Full"
                      disabled={!userGrantAccess}
                      checked={props.teamAccess["Facebook Ads"]["Full"] == "1"}
                      onChange={(e) => {
                        let accessChecked = props.teamAccess;
                        accessChecked["Facebook Ads"]["Restricted"] = "0";
                        accessChecked["Facebook Ads"]["Full"] = props.teamAccess["Facebook Ads"]["Full"] == "1" ? "0" : "1";
                        props.setTeamAccess({ ...accessChecked });
                      }}
                    />
                  </div>
                  <div className="pb-1 pl-3">
                    <CustomFormCheck
                      id="ob_facebook_ads_restricted"
                      name="facebook_ads_granted_restricted"
                      label="Restricted"
                      disabled={!userGrantAccess}
                      checked={props.teamAccess["Facebook Ads"]["Restricted"] == "1"}
                      onChange={(e) => {
                        let accessChecked = props.teamAccess;
                        accessChecked["Facebook Ads"]["Full"] = "0";
                        accessChecked["Facebook Ads"]["Restricted"] = props.teamAccess["Facebook Ads"]["Restricted"] == "1" ? "0" : "1";
                        props.setTeamAccess({ ...accessChecked });
                      }}
                    />
                  </div>
                </div>

                <div>
                  <p className="f12 pb-3 light-primary">
                    Note: Facebook Ads requires it's own specific process to grant access. Make sure to double-check with the client that all necessary steps have
                    been taken, all necessary access is granted, and then check the box to confirm.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      {/* <Col lg={4} className="mt-3">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/D_ObP3SFbww"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ maxWidth: "100%" }}></iframe>
      </Col> */}
      </Row>
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
